import { createContext as n, useState as l, useContext as o, useMemo as F } from "react";
import { jsx as f } from "react/jsx-runtime";
const u = {
  featureFlags: {},
  setFeatureFlags: () => null
}, a = n(u), x = ({
  value: e,
  children: t
}) => {
  const [s, r] = l(e ?? u.featureFlags);
  return /* @__PURE__ */ f(a.Provider, { value: { featureFlags: s, setFeatureFlags: r }, children: t });
}, y = (e) => {
  const { featureFlags: t } = o(a);
  return t[e] ?? !1;
}, m = () => {
  const { featureFlags: e } = o(a);
  return F(
    () => new c(e),
    [e]
  );
};
class c {
  constructor(t) {
    return new Proxy(this, {
      get(s, r) {
        if (typeof r == "symbol")
          throw new Error("FeatureFlagProxy cannot be indexed with symbol");
        return typeof t[r] > "u" ? !1 : t[r];
      }
    });
  }
}
export {
  x as F,
  m as a,
  a as f,
  y as u
};
//# sourceMappingURL=useFeatureFlag-yISLemKJ.js.map
